import Select, { SelectSize } from "./Select";

export default Select;
export { SelectSize };
